
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DeviceInfo, DeviceType } from '@/types/device-info';
import { deviceTypeEnum } from '@/constants/deviceType_enum';
import { getDatetimeDiff } from '@/utils/datetime';
import DeviceOptionsMenu from '@/components/devices/menus/DeviceOptionsMenu.vue';

// Airbolt default logo
import defaultAirboltLockImage from '@/assets/default-airboltLock-image.png';
import defaultCardImage from '@/assets/default-card-image.png';
import defaultGPSImage from '@/assets/default-gps-image.png';
import { voltage_to_capacity } from '@/utils/voltageToCapacity';
import { State } from 'vuex-class';
import { UserInfo } from '@/types/user-info';
import { userRoles } from '@/constants/userRoles';

@Component({
    components: { DeviceOptionsMenu },
})
export default class DeviceListRow extends Vue {
    @Prop({ required: true })
    device!: DeviceInfo;

    @Prop({ required: false, default: false })
    active!: boolean;

    @Prop({ required: false, default: true })
    deviceMenuOption!: boolean;

    @State('user')
    user!: UserInfo;

    deviceTypeEnum = deviceTypeEnum;
    getDatetimeDiff = getDatetimeDiff;
    DeviceTypes = DeviceType;
    deviceLastSeen = '';
    protected intervalSchedule: any = null;

    mounted() {
        this.intervalSchedule = setInterval(() => {
            this.updateDeviceTimeStamp();
        }, 600);
    }

    beforeDestroy() {
        if (this.intervalSchedule) this.resetInterval();
    }

    resetInterval() {
        clearInterval(this.intervalSchedule);
        this.intervalSchedule = null;
    }

    updateDeviceTimeStamp() {
        this.deviceLastSeen = this.device.lastSeenTime ? getDatetimeDiff(this.device.lastSeenTime) : 'N/A';
    }

    get image() {
        if (!this.device) return null;
        if (this.device?.devicePicture) return `data:image/png;base64,${this.device.devicePicture}`;
        if (this.device?.deviceType === DeviceType.AirboltTravelLock) return defaultAirboltLockImage;
        if (this.device?.deviceType === DeviceType.AirboltCard) return defaultCardImage;
        if (this.device?.deviceType === DeviceType.AirboltGps) return defaultGPSImage;
        return null;
    }

    @Watch('device', { immediate: true })
    async onDeviceChange() {
        this.updateDeviceTimeStamp();
    }

    get deviceTemperature() {
        return voltage_to_capacity(this.device.modem_voltage ?
            this.device.modem_voltage : 0)
    }

    get userPermission() {
        if (this.user.roles.includes(userRoles.Enterprise) || this.user.roles.includes(userRoles.Admin) || this.user.roles.includes(userRoles.SuperAdmin) || this.user.roles.includes(userRoles.EnterpriseNoApi)) {
            return true;
        }
        return false;
    }
}
